export const ActionTypes = {
  LOADING: "DELETE_DECISION_LOADING",
  ERROR: "DELETE_DECISION_ERROR",
  SUCCESS: "DELETE_DECISION_SUCCESS",
};
